import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/colors";

export const PageContainer = styled(Box)({
  padding: "0",
});


export const PatientDetailsCard = styled(Box)({
  display: "flex",
  gap: "24px",
  marginBottom: "32px",
});

export const PatientInfoSection = styled(Box)({
  flex: 1,
  display: "flex",
  backgroundColor: colors.background.default,
  borderRadius: "12px",
  padding: "20px 24px",
  gap: "40px",
});

export const PatientNameBlock = styled(Box)({
  display: "flex",
  flexDirection: "column",
  minWidth: "150px",
});

export const PatientDetailsLabel = styled(Typography)({
  fontSize: "12px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  marginBottom: "4px",
});

export const PatientName = styled(Typography)({
  fontSize: "18px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const PatientDetailColumn = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "8px",
});

export const PatientDetailItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
});

export const PatientDetailText = styled(Typography)({
  fontSize: "14px",
  color: colors.text.primary,
  fontFamily: "Nunito",
});

export const AllergiesSection = styled(Box)<{ hasAllergies?: boolean }>(
  ({ hasAllergies }) => ({
    backgroundColor: hasAllergies ? "#FFF5F4" : "#E6F4EE",
    borderRadius: "12px",
    padding: "16px 20px",
    minWidth: "200px",
  })
);

export const AllergiesLabel = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  marginBottom: "8px",
});

export const AllergiesLabelText = styled(Typography)<{
  hasAllergies?: boolean;
}>(({ hasAllergies }) => ({
  fontSize: "12px",
  color: hasAllergies ? colors.status.error : "#296C50",
  fontFamily: "Nunito",
}));

export const AllergiesText = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: colors.status.error,
  fontFamily: "Sora",
});

export const NoAllergiesText = styled(Typography)({
  fontSize: "16px",
  fontWeight: 600,
  color: "#296C50",
  fontFamily: "Sora",
});

export const SectionContainer = styled(Box)({
  marginBottom: "32px",
});

export const SectionHeader = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: "16px",
});

export const SectionTitle = styled(Typography)({
  fontSize: "20px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Sora",
});

export const SessionsTable = styled(Box)({
  backgroundColor: colors.background.secondary,
  borderRadius: "12px",
  overflow: "hidden",
  border: `1px solid ${colors.border.light}`,
});

export const TableHeader = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  padding: "16px 24px",
  backgroundColor: colors.background.secondary,
  borderBottom: `1px solid ${colors.border.light}`,
});

export const TableHeaderCell = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
  fontSize: "14px",
  fontWeight: 600,
  color: colors.text.primary,
  fontFamily: "Nunito",
  cursor: "pointer",
  "&:last-child": {
    justifyContent: "center",
  },
});

export const TableRow = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  padding: "16px 24px",
  borderBottom: `1px solid ${colors.border.light}`,
  "&:last-child": {
    borderBottom: "none",
  },
  "&:hover": {
    backgroundColor: colors.background.default,
  },
});

export const TableCell = styled(Box)({
  display: "flex",
  alignItems: "center",
  fontSize: "14px",
  color: colors.text.primary,
  fontFamily: "Nunito",
  "&:last-child": {
    justifyContent: "center",
    gap: "24px",
  },
});

export const ProviderCell = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const ProviderAvatar = styled(Box)({
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  backgroundColor: colors.background.default,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  "& img": {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
});

export const ProviderName = styled(Typography)({
  fontSize: "14px",
  fontWeight: 600,
  color: colors.text.link,
  fontFamily: "Nunito",
  cursor: "pointer",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const ActionLink = styled(Typography)({
  fontSize: "14px",
  color: colors.text.action,
  fontFamily: "Nunito",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const NoDataText = styled(Typography)({
  fontSize: "14px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
  textAlign: "center",
  padding: "40px",
});
